<template>
  <b-modal
    id="parenthood-preview-modal"
    class="custom-modal"
    centered
    title="Preview"
    body-class="py-3"
    hide-footer
    no-close-on-backdrop
  >
    <b-form-group>
      <template slot="label">
        Parenthood <span class="text-danger">*</span>
      </template>
      <b-row>
        <b-col md="5" class="mb-3 mb-md-0">
          <b-form-select value="month">
            <option v-for="(parenthoodOption, index) in parenthoodOptions" :key="index" :value="parenthoodOption">{{ parenthoodOption }}</option>
          </b-form-select>
        </b-col>
      </b-row>
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
    name: "ParenthoodModal",
    computed: {
        parenthoodOptions() {
            const parenthoodOptions = ["Parent", "Non-parent"];
            return parenthoodOptions;
        }
    }
};
</script>
